import { Container, Row, Col } from "react-bootstrap";
import { Form } from "antd";
import logo from "../assets/images/yelogo.png";
import { useState } from "react";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import IyeInput from "components/IyeInput";
import PasswordChangedModal from "components/PasswordChangedModal";
import { useNavigate } from "react-router-dom";

const CreatePassword = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [successOpen, setSuccessOpen] = useState(false);

  const onFinish = (values: any) => {
    console.log(values);
    // 👉 call reset password API here; on success:
    setSuccessOpen(true);
  };

  const [showNewPass, setShowNewPass] = useState(false);
const [showConfirmPass, setShowConfirmPass] = useState(false);

  return (
    <div className="login-bg">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="login-card">
              {/* LEFT PANEL (Form) */}
              <div className="login-left">
                <div className="login-form-wrap">
                  <h2 className="login-title mb-1">Reset password</h2>
                  <p className="login-subtitle mb-4">
                    Note: Password must be at least 8 characters long and
                    contain at least one uppercase letter.
                  </p>

                  <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    autoComplete="off"
                    className="login-form"
                  >
                  {/* USERNAME */}
                  <IyeInput
                    type={showNewPass ? "text" : "password"}
                    name="newPassword"
                    placeholder="New Password"
                    required
                    requiredMessage="Password is required"
                    prefix={<i className="fa fa-lock" />}
                    suffix={
                      showNewPass ? (
                        <EyeOutlined onClick={() => setShowNewPass(false)} />
                      ) : (
                        <EyeInvisibleOutlined
                          onClick={() => setShowNewPass(true)}
                        />
                      )
                    }
                  />

                  <IyeInput
                    type={showConfirmPass ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    required
                    requiredMessage="Password is required"
                    prefix={<i className="fa fa-lock" />}
                    suffix={
                      showConfirmPass ? (
                        <EyeOutlined
                          onClick={() => setShowConfirmPass(false)}
                        />
                      ) : (
                        <EyeInvisibleOutlined
                          onClick={() => setShowConfirmPass(true)}
                        />
                      )
                    }
                  />

                  <button
                    type="submit"
                    className="login-btn w-100 rounded-pill"
                    style={{ height: 54 }}
                  >
                    Confirm Password
                  </button>
                  </Form>
                </div>
              </div>

              {/* RIGHT PANEL (Illustration) */}
              <div className="login-right">
                <div className="login-illustration-circle">
                  <img src={logo} alt="IYE" className="login-illustration" />
                </div>
                <div className="login-illustration-caption">Smart Buyer</div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <PasswordChangedModal
        open={successOpen}
        onClose={() => setSuccessOpen(false)}
        onBackToLogin={() => navigate("/")}
      />
    </div>
  );
};

export default CreatePassword;
